<div class="d-flex flex-wrap justify-content-between mt-2">
    <div class="ms-2 mb-2 mb-sm-0">
      <span class="font-size-90 text-nowrap">
        Showing <span class="h5 fw-light">{{pageSize > results?.slice((pageNo-1)*pageSize, pageNo*pageSize)?.length ? results?.slice((pageNo-1)*pageSize, pageNo*pageSize)?.length : pageSize}} / {{results?.length || 0 }}</span> results
        <span class="text-muted fw-light ms-1" *ngIf="selectedResults?.length">({{selectedResults?.length}} selected)</span>
      </span>
    </div>
    <div class="d-flex ms-2 ms-sm-0 mb-2 mb-sm-0">
      <div class="d-flex align-items-center" *ngIf="pageSizeOption">
        <label for="page-size" class="font-size-90 fw-semibold text-nowrap me-1">Page Size</label>
        <select class="form-select form-select-sm font-size-90 border-0 border-bottom shadow-sm" id="page-size" [(ngModel)]="pageSize" (change)="pageSizeChange(pageSizeFilter.value);" #pageSizeFilter>
            <option *ngFor="let ps of pageSizeOptions" [value]="ps">{{ps}}</option>
        </select>
      </div>
      <div class="d-flex ms-2 align-items-center" *ngIf="results?.length >= pageSize && pageNoOption">
        <button type="button" class="btn btn-sm btn-outline-primary border shadow-sm rounded-circle me-1" appButton (click)="previousPage()" [hidden]="pageNo === 1" data-bs-placement="auto" title="Previous Page">
          <i class="mdi mdi-chevron-left"></i>
        </button>
        <!-- <p class="mb-0 fw-semibold font-size-90 mx-2">{{pageNo || 1 }}</p> -->
        <button type="button" class="btn btn-sm btn-outline-primary border shadow-sm rounded-circle" appButton (click)="nextPage()" [hidden]=" !results?.slice((pageNo-1)*pageSize, pageNo*pageSize)?.length || results?.slice((pageNo-1)*pageSize, pageNo*pageSize)?.length < pageSize" data-bs-placement="auto" title="Next Page">
          <i class="mdi mdi-chevron-right"></i>
        </button>
          <!-- <p class="mb-0 fw-semibold font-size-90 mx-2">Page No: {{pageNo || 1 }}</p> -->

      </div>
    </div>
  </div>